import { createApp } from 'vue'
import App from './App.vue'

// Vuetify
import 'vuetify/styles'
import "@mdi/font/css/materialdesignicons.css";
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/200.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/800.css';
import '@fontsource/roboto/900.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/700-italic.css';

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import colors from 'vuetify/lib/util/colors'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: 'myTheme',
    themes: {
      myTheme: {
        light: true,
        colors: {
          primary: colors.lightBlue.darken4,
          secondary: colors.cyan.darken2,
          surface: colors.grey.lighten5,
          background: "#ffffff",
          success: colors.green.darken1,
          warning: colors.yellow.darken2,
          error: colors.red.darken2,
          info: colors.lightBlue.lighten2,
          "on-primary": "#ffffff",
          "on-secondary": colors.cyan.lighten5,
          "on-surface": "#000000",
          "on-background": "#000000",
          "on-success": "#ffffff",
          "on-warning": "#ffffff",
          "on-error": "#ffffff",
          "on-info": "#ffffff",
          "on-label": colors.grey.darken4,
          "on-grid": colors.grey.lighten3,
          "on-bar1": colors.pink.lighten3,
          "on-bar2": colors.purple.lighten3
        }
      },
      myThemeDark: {
        dark: true,
        colors: {
          primary: colors.lightBlue.darken4,
          secondary: colors.grey.darken2,
          surface: "#303030",
          background: "#212121",
          success: colors.green.darken1,
          warning: colors.yellow.darken2,
          error: colors.red.darken2,
          info: colors.lightBlue.lighten2,
          "on-primary": "#ffffff",
          "on-secondary": colors.cyan.accent1,
          "on-surface": "#ffffff",
          "on-background": "#ffffff",
          "on-success": "#ffffff",
          "on-warning": "#ffffff",
          "on-error": "#ffffff",
          "on-info": "#ffffff",
          "on-label": colors.grey.lighten3,
          "on-grid": colors.grey.darken3,
          "on-bar1": colors.pink.darken2,
          "on-bar2": colors.purple.darken2
        }
      }
    }
  },

})

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';


import { createRouter, createWebHistory } from 'vue-router'
import routes from './services/Routes'
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)


createApp(App)
  .use(pinia)
  .use(vuetify)
  .use(router)
  .component('QuillEditor', QuillEditor)
  .component('VTimePicker', VTimePicker)
  .mount('#app')
